export const wednesdayAbbreviatedLowercase = "SJIIib";
export default {wednesdayAbbreviatedLowercase};